__turbopack_context__.v({
  "container": "SettingsPage-module__8LH4PW__container",
  "header": "SettingsPage-module__8LH4PW__header",
  "headerContent": "SettingsPage-module__8LH4PW__headerContent",
  "icon": "SettingsPage-module__8LH4PW__icon",
  "iconWrapper": "SettingsPage-module__8LH4PW__iconWrapper",
  "page": "SettingsPage-module__8LH4PW__page",
  "section": "SettingsPage-module__8LH4PW__section",
  "sectionTitle": "SettingsPage-module__8LH4PW__sectionTitle",
  "subtitle": "SettingsPage-module__8LH4PW__subtitle",
  "themesGrid": "SettingsPage-module__8LH4PW__themesGrid",
  "title": "SettingsPage-module__8LH4PW__title",
});
